import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InfoMessage, PopOutChart } from 'sharedComponents';
import { chartPlugins } from './constants';
import useDriveAnomalyChartConfig from './useChartConfig';
import { getValueType } from '../../../KPITrendChartList/helpers';
import { translate } from 'helpers/translateHelper';
import ReleventSignalsButton from './ReleventSignalButtonComponent';
import { getColumns, getTableData } from '../helpers';
import './style.scss';


const CoolingAnomalyChart = ({
    coolingAnomalyKPI,
    loadingStatus,
    assetDetails,
    isZoomed,
    actions,
    chartRef,
    chartHeight,
    mainChartHeader,
    popOutChartHeader,
    containerRef,
    mainChartBanner,
    retrainingStartDate,
    requestedSubmittedDate,
    retrainingCompletedDate,
    retrainingStatus,
    chartInstance,
    onChartReady
}) => {
    const [info, setInfo] = useState(false);

    const graphOptions = useDriveAnomalyChartConfig(
        coolingAnomalyKPI,
        actions?.removeSelectedKpiLegend,
        coolingAnomalyKPI?.name,
        assetDetails,
        translate(getValueType(coolingAnomalyKPI?.valueType?.toLowerCase())),
        coolingAnomalyKPI?.conditionTrends,
        { containerRef, chartInstance, chartHeight, retrainingStartDate, requestedSubmittedDate, retrainingCompletedDate, retrainingStatus }
    );

    return (
        <>
            <PopOutChart
                hasKpi={!!coolingAnomalyKPI?.key}
                renderNoKpi={() => <InfoMessage
                    title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                    text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />}
                hasData={!!coolingAnomalyKPI?.conditionTrends?.length}
                renderNoData={() => <InfoMessage
                    title='ABB.Powertrain.Frontend.chartNoMeasurementData'
                    text='ABB.Powertrain.Frontend.chartNoMeasurementDataUserGuide' />}
                enableUniqueScaling={false}
                isZoomed={isZoomed}
                resetServerZoom={() => actions?.reloadConditionInsights?.(assetDetails?.id)}
                setIsZoomed={actions?.setIsZoomed}
                loadingStatus={loadingStatus}
                options={graphOptions}
                modules={chartPlugins}
                container={'drive-anomaly-detection-chart'}
                popOutClassName='drive-anomaly-detection-popout'
                mainChartHeader={mainChartHeader}
                popOutChartHeader={popOutChartHeader || mainChartHeader}
                chartRef={chartRef}
                onChartReady={onChartReady}
                chartInstance={chartInstance}
                popOutFooter={
                    <div className='relevent-signals-popout-wrapper'>
                        <ReleventSignalsButton
                            info={info}
                            setInfo={setInfo}
                            getColumns={getColumns}
                            getTableData={() => getTableData(coolingAnomalyKPI)}
                        />
                    </div>
                }
                mainChartBanner={mainChartBanner}
            />
            <ReleventSignalsButton
                info={info}
                setInfo={setInfo}
                getColumns={getColumns}
                getTableData={() => getTableData(coolingAnomalyKPI)}
            />
        </>
    );
};

CoolingAnomalyChart.propTypes = {
    coolingAnomalyKPI: PropTypes.object,
    loadingStatus: PropTypes.string,
    assetDetails: PropTypes.object,
    isZoomed: PropTypes.bool,
    actions: PropTypes.shape({
        removeSelectedKpiLegend: PropTypes.func,
        setIsZoomed: PropTypes.func,
        reloadConditionInsights: PropTypes.func
    }),
    chartRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    chartHeight: PropTypes.number,
    mainChartHeader: PropTypes.elementType,
    popOutChartHeader: PropTypes.elementType,
    containerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    mainChartBanner: PropTypes.node,
    retrainingStartDate: PropTypes.string,
    requestedSubmittedDate: PropTypes.string,
    retrainingCompletedDate: PropTypes.string,
    retrainingStatus: PropTypes.string,
    chartInstance: PropTypes.object,
    onChartReady: PropTypes.func
};

export default CoolingAnomalyChart;
